// Kernel render `link` clicks -> navigationStore intents, so every host
// (Library, canvases, the activity chart, chat) navigates through App's
// mode-aware helpers instead of writing Explore URL state itself.

import { DIMENSIONS } from "./dimensionDefs.js";
import { requestNavigation } from "./navigationStore.js";

// Opens the link's id as an Explore scope. Returns null for an unusable link.
export function kernelLinkIntent({ dim, ids } = {}) {
  const cleanIds = Array.isArray(ids) ? ids.filter((x) => typeof x === "string" && x.length > 0) : [];
  if (cleanIds.length === 0 || !DIMENSIONS[dim]) return null;
  return { kind: "workspace", scopePath: [{ dim, ids: cleanIds }] };
}

export function openKernelLink(link) {
  const intent = kernelLinkIntent(link);
  if (intent) requestNavigation(intent);
}
